"use client"

import { Shrub } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `ShrubIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const ShrubIcon = component(Icon)({ as: Shrub })
